import { SearchEngine } from '@coveo/headless';
import { buildSitesHeadlessEngine } from './sitesHeadlessEngineConfiguration';

/** Isolated engine for SavedSiteCarousel (avoids AQ/sort races with nearby / LocationSearch). */
// eslint-disable-next-line @typescript-eslint/ban-types
const savedSitesHeadlessEngine: SearchEngine<{}> = buildSitesHeadlessEngine({
  analyticsEnabled: false,
});

export default savedSitesHeadlessEngine;
